import { NavLink, Outlet } from 'react-router'

import { SECTION_LIST } from '#app/routes/mocra+/_sections+/section-data.ts'
import { cn } from '#app/utils/misc.tsx'

const sectionNavItems = SECTION_LIST.map((item) => {
	const sectionCode = item.title.match(/^§\d+/)?.[0]
	const code = sectionCode ?? (item.id === 'overview' ? null : item.id)
	const title = sectionCode
		? item.title.replace(/^§\d+\s+/, '')
		: item.id === 'overview'
			? 'MoCRA Overview'
			: item.title
	return {
		to: `/mocra/${item.id}`,
		code,
		title,
	}
})

export default function MocraSectionsLayout() {
	return (
		<div className="flex flex-col gap-8 pb-16 lg:flex-row">
			<aside className="lg:w-80">
				<div className="sticky top-24 space-y-4">
					<nav className="flex gap-2 overflow-x-auto lg:flex-col lg:gap-2">
						{sectionNavItems.map((item) => (
							<NavLink
								key={item.to}
								to={item.to}
								className={({ isActive }) =>
									cn(
										'flex min-h-12 items-center gap-2 rounded-md px-3 py-2 text-xs transition-colors',
										isActive
											? 'bg-primary/10 text-primary'
											: 'text-muted-foreground hover:bg-muted/60 hover:text-foreground',
									)
								}
							>
								{item.code ? (
									<>
										<span className="text-muted-foreground font-mono text-xs tracking-tight">
											{item.code}
										</span>
										<span className="text-muted-foreground">—</span>
									</>
								) : null}
								<span className="text-sm leading-snug font-medium">
									{item.title}
								</span>
							</NavLink>
						))}
					</nav>
				</div>
			</aside>
			<main className="flex-1 space-y-8">
				<Outlet />
			</main>
		</div>
	)
}
